import React from 'react';
import OriginalProfile from './OriginalProfile';
import MarketingEditor from './MarketingEditor';


interface EditProfilePopupProps {
  selectedDoctorId: number;
  onClose: () => void;
}
const EditProfilePopup: React.FC<EditProfilePopupProps> = ({
  selectedDoctorId,
  onClose
}) => {
 
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-2xl w-[95%] h-[90vh] flex flex-col">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6  border-b border-gray-200">
          <h2 className="text-lg  font-bold text-gray-900">
            Profile Edit
          </h2>
          <button
          onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            title="Close"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

    
        <div className="flex-1 overflow-y-auto px-6 ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 ">
            <OriginalProfile doctorId={selectedDoctorId} />
            <MarketingEditor doctorId={selectedDoctorId}     onClose={onClose}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfilePopup;
